import styled from "@emotion/styled";

import { ArticleFooter } from "~/components/article/article-footer";
import { Loading } from "~/components/common/loading";
import { setFullViewportWidthWithMaxPageWidthStyles } from "~/lib/styles";

export const StyledLoading = styled(Loading)`
  margin-block-end: 40px;
`;

export const Divider = styled.div`
  position: relative;

  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;

  block-size: 1px;
  margin-block-end: 40px;

  background-color: #dddddd;

  &::before,
  &::after {
    content: "";

    display: block;
    flex: none;

    inline-size: 30px;
    block-size: 5px;

    outline: #ffffff solid 4px;
  }

  &::before {
    background-color: #ffca05;
  }

  &::after {
    background-color: #001246;
  }

  &:last-child {
    display: none;
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 22px;
  }

  ${props => props.theme.breakpoints.only("mobile")} {
    ${setFullViewportWidthWithMaxPageWidthStyles()}
  }
`;

export const Item = styled.div`
  position: relative;

  padding-block-end: 40px;
`;

export const Footer = styled(ArticleFooter)`
  max-inline-size: 1208px;
  margin-inline: auto;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 80px;
  }
`;
